var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServicosSistemaWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 195,
    viewBox: "0 0 353 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M267.776 0H84.1429C82.5691 0.00617102 81.062 0.681514 79.9529 1.87757C78.8438 3.07362 78.2235 4.69248 78.2283 6.37829V141.76C78.2235 143.445 78.8438 145.064 79.9529 146.26C81.062 147.456 82.5691 148.132 84.1429 148.138H147.3V171.507H144.421C144.025 171.508 143.634 171.593 143.27 171.757C142.905 171.92 142.574 172.159 142.295 172.459C142.017 172.76 141.797 173.116 141.647 173.508C141.497 173.9 141.42 174.319 141.422 174.743V179.431H147.3V182.205H204.619V179.431H210.497V174.743C210.498 174.319 210.422 173.9 210.272 173.508C210.122 173.116 209.902 172.76 209.623 172.459C209.345 172.159 209.014 171.92 208.649 171.757C208.284 171.593 207.893 171.508 207.498 171.507H204.789V171.305H204.604V148.138H267.776C269.349 148.132 270.857 147.456 271.966 146.26C273.075 145.064 273.695 143.445 273.69 141.76V6.37829C273.695 4.69248 273.075 3.07362 271.966 1.87757C270.857 0.681514 269.349 0.00617102 267.776 0Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.426 144.114H147.855V179.851H204.426V144.114Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.968 147.61H203.425C204.082 144.553 204.608 142.56 204.608 142.56H147.673C147.673 142.56 148.257 144.545 148.968 147.61Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.5173 1.16541H266.764C268.312 1.16541 269.797 1.82431 270.892 2.99715C271.987 4.17 272.602 5.76073 272.602 7.41939V127.022H79.6788V7.41939C79.6788 5.76073 80.294 4.17 81.3889 2.99715C82.4838 1.82431 83.9688 1.16541 85.5173 1.16541Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.764 146.444H85.5173C83.9688 146.444 82.4838 145.785 81.3889 144.613C80.294 143.44 79.6788 141.849 79.6788 140.19V127.022H272.602V140.19C272.602 141.849 271.987 143.44 270.892 144.613C269.797 145.785 268.312 146.444 266.764 146.444Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14 140.229C177.943 140.229 179.404 138.664 179.404 136.733C179.404 134.802 177.943 133.237 176.14 133.237C174.338 133.237 172.877 134.802 172.877 136.733C172.877 138.664 174.338 140.229 176.14 140.229Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.015 169.363H207.266C208.051 169.363 208.805 169.697 209.361 170.292C209.916 170.887 210.228 171.694 210.228 172.536V177.131H142.052V172.536C142.052 172.119 142.129 171.707 142.278 171.322C142.427 170.937 142.645 170.587 142.92 170.292C143.195 169.997 143.522 169.764 143.881 169.604C144.241 169.445 144.626 169.363 145.015 169.363Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M234.344 27.6263H117.937C117.036 27.6263 116.305 28.409 116.305 29.3744V98.813C116.305 99.7784 117.036 100.561 117.937 100.561H234.344C235.245 100.561 235.976 99.7784 235.976 98.813V29.3744C235.976 28.409 235.245 27.6263 234.344 27.6263Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.81 28.1624H119.471C118.57 28.1624 117.839 28.945 117.839 29.9104V97.8729C117.839 98.8383 118.57 99.6209 119.471 99.6209H232.81C233.711 99.6209 234.442 98.8383 234.442 97.8729V29.9104C234.442 28.945 233.711 28.1624 232.81 28.1624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.541 38.4213H151.953C151.051 38.4213 150.321 39.2039 150.321 40.1693V49.0647C150.321 50.0301 151.051 50.8127 151.953 50.8127H161.541C162.442 50.8127 163.173 50.0301 163.173 49.0647V40.1693C163.173 39.2039 162.442 38.4213 161.541 38.4213Z",
    fill: "#112969"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.086 38.4213H167.669C167.315 38.4213 167.027 38.7291 167.027 39.1088C167.027 39.4885 167.315 39.7964 167.669 39.7964H201.086C201.441 39.7964 201.728 39.4885 201.728 39.1088C201.728 38.7291 201.441 38.4213 201.086 38.4213Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23 42.5543H167.669C167.315 42.5543 167.027 42.8621 167.027 43.2419C167.027 43.6216 167.315 43.9294 167.669 43.9294H195.23C195.584 43.9294 195.872 43.6216 195.872 43.2419C195.872 42.8621 195.584 42.5543 195.23 42.5543Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.541 57.6959H151.953C151.051 57.6959 150.321 58.4785 150.321 59.4439V68.3393C150.321 69.3047 151.051 70.0873 151.953 70.0873H161.541C162.442 70.0873 163.173 69.3047 163.173 68.3393V59.4439C163.173 58.4785 162.442 57.6959 161.541 57.6959Z",
    fill: "#112969"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.086 57.6959H167.669C167.315 57.6959 167.027 58.0037 167.027 58.3835C167.027 58.7632 167.315 59.071 167.669 59.071H201.086C201.441 59.071 201.728 58.7632 201.728 58.3835C201.728 58.0037 201.441 57.6959 201.086 57.6959Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.086 61.8251H167.669C167.315 61.8251 167.027 62.1329 167.027 62.5126C167.027 62.8923 167.315 63.2002 167.669 63.2002H201.086C201.441 63.2002 201.728 62.8923 201.728 62.5126C201.728 62.1329 201.441 61.8251 201.086 61.8251Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.541 76.9706H151.953C151.051 76.9706 150.321 77.7532 150.321 78.7186V87.614C150.321 88.5794 151.051 89.362 151.953 89.362H161.541C162.442 89.362 163.173 88.5794 163.173 87.614V78.7186C163.173 77.7532 162.442 76.9706 161.541 76.9706Z",
    fill: "#112969"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.086 76.9706H167.669C167.315 76.9706 167.027 77.2784 167.027 77.6581C167.027 78.0379 167.315 78.3457 167.669 78.3457H201.086C201.441 78.3457 201.728 78.0379 201.728 77.6581C201.728 77.2784 201.441 76.9706 201.086 76.9706Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.384 81.0997H167.604C167.286 81.0997 167.027 81.3763 167.027 81.7174V81.8572C167.027 82.1983 167.286 82.4748 167.604 82.4748H201.384C201.702 82.4748 201.96 82.1983 201.96 81.8572V81.7174C201.96 81.3763 201.702 81.0997 201.384 81.0997Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 16.3147V7.76892",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 30.6872V19.4728",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14 32.241C176.942 32.241 177.591 31.5453 177.591 30.6872C177.591 29.8291 176.942 29.1334 176.14 29.1334C175.339 29.1334 174.69 29.8291 174.69 30.6872C174.69 31.5453 175.339 32.241 176.14 32.241Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14 19.4223C176.942 19.4223 177.591 18.7266 177.591 17.8685C177.591 17.0104 176.942 16.3147 176.14 16.3147C175.339 16.3147 174.69 17.0104 174.69 17.8685C174.69 18.7266 175.339 19.4223 176.14 19.4223Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 16.3147V7.76892",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 30.6872V19.4728",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14 32.241C176.942 32.241 177.591 31.5453 177.591 30.6872C177.591 29.8291 176.942 29.1334 176.14 29.1334C175.339 29.1334 174.69 29.8291 174.69 30.6872C174.69 31.5453 175.339 32.241 176.14 32.241Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14 19.4223C176.942 19.4223 177.591 18.7266 177.591 17.8685C177.591 17.0104 176.942 16.3147 176.14 16.3147C175.339 16.3147 174.69 17.0104 174.69 17.8685C174.69 18.7266 175.339 19.4223 176.14 19.4223Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 108.376V120.418",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.141 97.5V108.714",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14 99.0537C176.942 99.0537 177.591 98.3581 177.591 97.5C177.591 96.6418 176.942 95.9462 176.14 95.9462C175.339 95.9462 174.69 96.6418 174.69 97.5C174.69 98.3581 175.339 99.0537 176.14 99.0537Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.866 65.4532H99.4425",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.838 65.4532H110.369",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.838 67.007C121.639 67.007 122.289 66.3113 122.289 65.4532C122.289 64.5951 121.639 63.8994 120.838 63.8994C120.037 63.8994 119.388 64.5951 119.388 65.4532C119.388 66.3113 120.037 67.007 120.838 67.007Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M204.608 169.168H148.036V170.334H204.608V169.168Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M64.9849 142.583H38.7299L39.0925 139.421C46.5121 132.285 51.3098 113.275 51.3098 113.275C51.2033 113.291 51.0979 113.314 50.9943 113.345C46.6426 114.285 43.5457 116.2 41.3807 118.503L42.3018 110.09C56.0096 106.928 61.4455 87.5053 61.4455 87.5053C52.6987 89.5835 47.2446 92.7998 43.8576 95.853L45.2066 83.4926C54.4756 86.8993 64.0638 68.8016 64.0638 68.8016L63.7011 68.72L63.8824 68.5957L63.6068 68.7006C53.3623 66.3349 47.8865 72.6084 46.1095 75.2148L46.2437 74.0029C45.973 74.7798 45.7094 75.5411 45.4532 76.287V76.318C44.7279 78.4234 44.0643 80.5029 43.4623 82.5565C42.9377 84.3097 42.4469 86.0447 41.99 87.7616V87.7383C41.99 87.7383 41.5657 76.6832 30.6829 73.7737C30.6829 73.7737 31.8252 97.8846 40.4488 93.9379C39.651 97.434 38.9982 100.798 38.4325 104.065C38.0723 106.191 37.758 108.263 37.4896 110.28L37.4389 110.342L37.4896 110.295L37.4679 110.455C37.2261 112.286 37.0206 114.07 36.8514 115.807C37.0182 112.459 36.4489 102.787 25.8091 93.6971C25.8091 93.6971 11.6662 120.321 35.7816 125.55C35.836 125.6 35.8904 125.651 35.9412 125.697L35.9049 125.577L36.1225 125.627L36.2204 124.26C35.9297 129.967 35.9575 135.687 36.3038 141.391C36.3292 141.779 36.3546 142.167 36.38 142.536H9.82398C-0.308124 164.985 15.4521 177.287 15.4521 177.287H58.9687C75.8676 154.47 64.9849 142.583 64.9849 142.583Z",
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.2501 151.106C37.2501 151.106 30.36 118.865 45.5908 77.3008",
    stroke: "#535461",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.415 141.394H63.7228C63.7228 141.394 74.2393 155.767 57.9206 177.131H15.8546C15.8546 177.131 0.623792 162.371 10.415 141.394Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8256 79.4372C44.8256 79.4372 50.1237 69.3376 62.8161 72.4452C62.8161 72.4452 52.3249 91.5801 42.871 85.3144L44.8256 79.4372Z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4677 90.1545C41.4677 90.1545 41.0579 79.8257 30.5414 77.1066C30.5414 77.1066 31.6293 99.6365 39.97 95.9462L41.4677 90.1545Z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0298 105.409C38.0298 105.409 39.97 94.5866 60.2777 89.9253C60.2777 89.9253 53.801 112.308 37.0942 111.41L38.0298 105.409Z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3834 117.555C36.3834 117.555 38.5194 106.24 25.827 95.752C25.827 95.752 12.0468 120.873 35.7923 125.596L36.3834 117.555Z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0027 133.109C36.0027 133.109 34.5303 117.116 50.4864 114.009C50.4864 114.009 44.6588 136.341 35.9809 140.322L36.0027 133.109Z",
    fill: "#4DB6AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.0524 85.4581C43.0524 85.4581 56.8326 74.1932 62.6348 72.251",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M37.0688 111.29C37.0688 111.29 53.7502 92.256 60.2777 89.9253",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M30.5414 77.1066C30.5414 77.1066 40.6952 91.8675 39.97 95.752",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M25.827 95.752C25.827 95.752 31.2666 122.166 35.6182 125.662",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M35.981 140.423C35.981 140.423 44.6843 114.786 50.4865 114.009",
    stroke: "#535461",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.7227 141.394H10.4149C10.2952 141.655 10.1792 141.915 10.0522 142.171H61.9095C61.9095 142.171 72.1685 156.198 56.6875 177.131H57.9204C74.2392 155.767 63.7227 141.394 63.7227 141.394Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.281 176.976H0V189.768H352.281V176.976Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.351 189.768H14.9261V195H337.351V189.768Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M337.351 189.768H14.9261V191.512H337.351V189.768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3 65.4532H252.476",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08 65.4532H247.355",
    stroke: "#112969",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08 67.007C231.881 67.007 232.531 66.3113 232.531 65.4532C232.531 64.5951 231.881 63.8994 231.08 63.8994C230.279 63.8994 229.63 64.5951 229.63 65.4532C229.63 66.3113 230.279 67.007 231.08 67.007Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.849 67.007C249.651 67.007 250.3 66.3113 250.3 65.4532C250.3 64.5951 249.651 63.8994 248.849 63.8994C248.048 63.8994 247.399 64.5951 247.399 65.4532C247.399 66.3113 248.048 67.007 248.849 67.007Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M330.987 172.812L331.023 172.754C331.098 172.629 331.172 172.5 331.244 172.365L331.284 172.291C331.354 172.165 331.421 172.035 331.484 171.903L331.516 171.837C331.589 171.685 331.658 171.534 331.719 171.375C331.85 171.057 331.964 170.731 332.06 170.4L332.097 170.272C332.129 170.151 332.162 170.031 332.191 169.91L332.227 169.739C332.251 169.631 332.273 169.521 332.292 169.409C332.292 169.347 332.314 169.285 332.325 169.223C332.336 169.161 332.358 169.005 332.372 168.893C332.387 168.78 332.372 168.764 332.394 168.702C332.416 168.64 332.416 168.465 332.423 168.345C332.423 168.29 332.423 168.232 332.423 168.178C332.423 168.003 332.423 167.824 332.423 167.65V135.568H327.4V119.843H321.236V135.568H316.985V112.983H310.821V135.568H308.503V109.755H302.338V135.568H296.899V167.653C296.899 172.89 300.964 177.132 305.965 177.132H323.372C324.795 177.138 326.199 176.787 327.474 176.109C328.748 175.43 329.857 174.442 330.711 173.224C330.801 173.086 330.893 172.949 330.987 172.812Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.866 124.691H303.064V163.536H308.866V124.691Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.866 111.873H303.064V124.691H308.866V111.873Z",
    fill: "#3AD29F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.844 127.799H311.042V166.643H316.844V127.799Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.844 114.98H311.042V127.799H316.844V114.98Z",
    fill: "#4D8AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.635 134.402H320.833V173.247H326.635V134.402Z",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.635 121.584H320.833V134.402H326.635V121.584Z",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.987 136.733H331.349V167.614C331.349 170.036 330.452 172.357 328.853 174.069C327.255 175.781 325.088 176.743 322.828 176.743H306.509C304.249 176.743 302.081 175.781 300.483 174.069C298.885 172.357 297.987 170.036 297.987 167.614V136.733Z",
    fill: "#112969"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M297.987 136.733V138.287H329.899V169.168C329.902 171.209 329.263 173.192 328.086 174.797C329.103 173.944 329.926 172.854 330.492 171.609C331.057 170.365 331.351 168.999 331.349 167.615V136.733H297.987Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 175.959,
    y1: 182.201,
    x2: 175.959,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 58242.7,
    y1: 18909,
    x2: 58242.7,
    y2: 5214.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 8191.32,
    y1: 56259.6,
    x2: 18794.5,
    y2: 56259.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 33440.8,
    y1: 38398.2,
    x2: 36922.2,
    y2: 38398.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352.281,
    height: 195,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicosSistemaWeb);
export default __webpack_public_path__ + "static/media/servicos_sistema_web.17d61a053820c44fd8cdc43b177e0ee0.svg";
export { ForwardRef as ReactComponent };